import PropTypes from 'prop-types';

import TableHeaderField from './table-header-field';
import { TableHeadCell } from './table-header-field.styled';
import { TableHead, TableRow } from './table.header.styled';

export const TableHeader = (props) => {
  const { fields, actions, theme, $sticky, withCheck, selectAll, withCheckChecked } = props;
  const cl = $sticky ? 'sticky' : '';
  return (
    <TableHead className={cl}>
      <TableRow>
        {withCheck && (
          <TableHeadCell key="selectAll" theme={theme} title="Выбрать всё" width="55">
            <input type="checkbox" onChange={() => selectAll()} checked={withCheckChecked} />
          </TableHeadCell>
        )}
        {fields
          .filter((el) => !el.isHidden)
          .map((field, idx) => (
            <TableHeaderField key={idx} {...field} theme={theme} />
          ))}
        {actions && actions.length > 0 && <TableHeaderField key={'table-actions'} width={80} title="" theme={theme} />}
      </TableRow>
    </TableHead>
  );
};

TableHeader.propTypes = {
  fields: PropTypes.array.isRequired,
  actions: PropTypes.array,
  selectAll: PropTypes.func.isRequired,
  withCheck: PropTypes.bool,
  withCheckChecked: PropTypes.bool,
};
